import { Form, Radio } from 'antd';

import { OptionInterface, RadioTplType } from '../types/tplTypes';

export const RadioTpl = ({
  className,
  data,
}: {
  className?: string;
  data: RadioTplType;
}) => {
  const key = data.valueField || 'key';
  const label = data.labelField || 'value';

  return (
    <Form.Item
      name={data.id}
      label={data?.label}
      className={className}
      {...(data.formItemProps || {})}
    >
      <Radio.Group
        disabled={data.disabled}
        key={'key_' + Math.random()}
        {...(data.componentProps || {})}
      >
        {data.options.map((item: OptionInterface) => {
          return (
            <Radio
              key={item[key] + '_' + item.value}
              value={item[key]}
              disabled={item.disabled}
            >
              {item[label]}
            </Radio>
          );
        })}
      </Radio.Group>
    </Form.Item>
  );
};
